module.exports = __webpack_public_path__ + "img/navbar-global.88c19cb7.svg";